import {
  GET_CHANGE_HISTORY,
  GET_CHANGE_HISTORY_ERROR,
  GET_CHANGE_HISTORY_EXPORT,
  GET_CHANGE_HISTORY_EXPORT_ERROR,
  GET_CHANGE_HISTORY_EXPORT_SUCCESS,
  GET_CHANGE_HISTORY_SUCCESS
} from "./actionTypes"

export const getChangeHistory = (query_params, paginated) => {
  return {
    type: GET_CHANGE_HISTORY,
    payload: query_params,
    paginated: paginated
  }
}

export const getChangeHistorySuccess = (change_history, meta = {}) => {
  return {
    type: GET_CHANGE_HISTORY_SUCCESS,
    payload: change_history,
    meta,
  }
}

export const getChangeHistoryError = error => {
  return {
    type: GET_CHANGE_HISTORY_ERROR,
    payload: error
  }
}

export const getChangeHistoryExport = (query_params) => {
  return {
    type: GET_CHANGE_HISTORY_EXPORT,
    payload: query_params
  }
}

export const getChangeHistoryExportSuccess = () => {
  return {
    type: GET_CHANGE_HISTORY_EXPORT_SUCCESS
  }
}

export const getChangeHistoryExportError = () => {
  return {
    type: GET_CHANGE_HISTORY_EXPORT_ERROR
  }
}
